export type ManagerHomeSection = 'needs_assignment' | 'in_flight' | 'coder_complete';

export interface ManagerHomeGrader {
  id: string;
  firstName: string;
  lastName: string;
  assignedVolume: number;
  totalCount?: number | null;
  completedCount?: number | null;
}

export interface ManagerHomeProject {
  id: string;
  ruleId: string;
  name: string;
  groupLabel: string;
  groupId: string;
  purpose: string | null;
  endDate: string | null;
  createdAt: string;
  section: ManagerHomeSection;
  totalCount: number | null;
  completeCount: number | null;
  approvedCount: number | null;
  lastActivityAt?: string | null;
  graderCount?: number | null;
  isMultiGrader?: boolean | null;
  codeTypes?: string[];
  rubricId?: number | null;
  rubricName?: string | null;
  graders?: ManagerHomeGrader[];
}

export interface ManagerHomeGroup {
  id: string;
  label: string;
}

export type AtRiskTier = 'overdue' | 'due-soon' | 'none';

export const SECTION_ORDER: ManagerHomeSection[] = [
  'needs_assignment',
  'in_flight',
  'coder_complete',
];

export const SECTION_LABELS: Record<ManagerHomeSection, string> = {
  needs_assignment: 'Needs Assignment',
  in_flight: 'Active Projects',
  coder_complete: 'For Review',
};
